<script lang="ts">
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import Banner from "@shared/svelte/Components/Banner/Banner.svelte";
  import { getInternalBanner } from "@shared/services/banner_service";

  export let mobileMode: boolean = false;
  export let pageName: string;
  export let pageValue: string | null = null;
  mobileMode;

  let loaded: boolean = false;

  let banners;
  getInternalBanner(pageName, pageValue).then(res => {
    loaded = true;
    banners = res;
  });

  $: innerWidth = 0;
  $: mobileModeBanner = innerWidth < 480;

  $: skeletonHeight = mobileModeBanner ? 85 : 150;
  $: skeletonWidth = mobileModeBanner ? 390 : 1300;
</script>

<svelte:window bind:innerWidth />
<div class="fizz-styles" data-testid="self-fetching-banner">
  {#if !loaded}
    <div class="fizz-grid-center fizz-stack-24">
      <Skeleton animate={true} height={skeletonHeight} width={skeletonWidth} />
    </div>
  {:else}
    <Banner {banners} {mobileMode} {pageName} />
  {/if}
</div>
